export default {
    setList(state, data) {
        state.list = data.alerts.data
        state.total = data.alerts.total
    }
}
